export {
  arrayIsShallowEqual,
  BackendAllErrorCodes,
  BackendDeleteResponse,
  BackendErrorResponse,
  BackendPushErrorResponse,
  BackendPushResponse,
  BackendSetResponse,
  BackendSuccessResponse,
  BackendUpdateErrorResponse,
  BackendUpdateResponse,
  Datastore,
  datastoreActionSanitizer,
  DatastoreCollection,
  DatastoreCollectionType, // FIXME: Remove this once the external datastore mocks are removed
  DatastoreDocument,
  DatastoreModule,
  DocumentQuery,
  flatten,
  isNumeric,
  keyBy,
  MapCoordinates,
  objectFilter,
  OrderByDirection,
  partition,
  Query,
  RecursivePartial,
  StoreBackendInterface,
  toObservable,
  uniq,
  uniqWith,
} from './core';
export {
  TestingCollection, // FIXME: Remove this once the external datastore mocks are removed
} from './core/testing/types';
// TODO: REMOVE THESE PRIVATE EXPORTS
export { DATASTORE_CONFIG } from './core/datastore.config';
export {
  ErrorResponseData,
  HttpAdapter,
  LOGGED_OUT_KEY,
  ResponseData,
  SuccessResponseData,
} from './core/datastore.interface';
export {
  DatastoreFake,
  DatastoreFakeModule,
  StoreBackendFake,
} from './core/fake';
export { generateId } from './core/fake/mocks/random';
export * from './core/operators';
export {
  RequestError,
  RequestErrorWithoutRetry,
  RequestStatus,
  RequestStatusWithoutRetry,
} from './core/request-status-handler.service';
export * from './core/testing';
export { TimeMilliseconds } from './core/time/time.model';
export {
  isWebsocketMessage,
  WebsocketContestData,
  WebsocketMessage,
  WebsocketProjectData,
  WebSocketService,
} from './core/websocket';
